import { useHookstate } from '@hookstate/core';
import { FC } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { CongratulationsPanel } from '../../components/CongratulationsPanel';
import { Part } from '../../components/GamePart';
import { GoodluckPanel } from '../../components/GoodluckPanel';
import { SalesClosedModal } from '../../components/SalesClosedModal';
import { useBoughtTickets } from '../../hooks/use-bought-tickets';
import { useCountdown } from '../../hooks/use-countdown';
import { useCurrentPartsSize } from '../../hooks/use-current-parts-size';
import { usePartWinners } from '../../hooks/use-part-winners';
import { current, meta } from '../../stores/backend';
import { CountdownModal } from '../CountDownModal';
import { PromoAdPanel } from '../PromoAdPanel';

export const GameStatePanelContainer = styled.div`
    width: 100%;
    margin-bottom: ${isMobile ? '1rem' : '0.5rem'};
`;

export const GameStatePanel: FC = () => {
    const $current = useHookstate(current);
    const $meta = useHookstate(meta);

    const bought = useBoughtTickets($current);

    const { seconds } = useCountdown(new Date($meta.timer.date.value));

    const currentPart = $current.current_part.value || 0;

    const parts = useCurrentPartsSize();

    const partWinners = usePartWinners();

    if (partWinners) {
        $meta.panels.partWinner.set(true);
        return (
            <GameStatePanelContainer>
                <CongratulationsPanel
                    winners={partWinners}
                    part={(currentPart + 1) as Part}
                    gameParts={parts as Part}
                />
            </GameStatePanelContainer>
        );
    }

    if ($current.game_mode.value !== 'GAME_MODE' || bought === 0) {
        if (seconds > 10) {
            return (
                <GameStatePanelContainer>
                    <PromoAdPanel />
                    {seconds <= 20 && <SalesClosedModal />}
                </GameStatePanelContainer>
            );
        }

        if (seconds > 0) {
            return (
                <GameStatePanelContainer>
                    <GoodluckPanel />
                    <CountdownModal />
                </GameStatePanelContainer>
            );
        }
    }

    $meta.panels.partWinner.set(false);
    return null;
};
